import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import CustomerInventoryLocations from './CustomerInventoryLocations'
import InventoryLocationsMap from './InventoryLocationsMap'
import CustomerTransactions from './CustomerTransactions'
import Typography from '@material-ui/core/Typography'
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import _ from 'lodash'
import CircularProgress from '@material-ui/core/CircularProgress';
import CustomerUsers from './CustomerUsers';
import { inject, observer } from 'mobx-react';
import {pending, done} from '../stores/State'
import { autorun } from 'mobx';
import Button from '@material-ui/core/Button'
import Settings from '@material-ui/icons/Settings';

@inject('store')
@observer
class Customer extends Component {
  
  componentWillMount(){
    this.fetchCustomer();
    this.fetchInventoryLocations();
  }

  fetchCustomer(){
    const store  = this.props.store.customerStore;
    store.fetchCustomer(this.props.match.params.id)
  }

  fetchInventoryLocations(){
    const { inventoryLocationStore } = this.props.store;
    inventoryLocationStore.fetchCustomerInventoryLocations(this.props.match.params.id);
  }

  render() {
    const { classes } = this.props;
    const store  = this.props.store.customerStore;    
    const customer  = store.customer;        
    const customerId = _.parseInt(this.props.match.params.id);

    if(store.customerState === pending) return <CircularProgress />
    if(!customer) return null;

    return (
      <Grid container spacing={24}>
        <Grid item xs={12}>
          <Typography variant='display3'>{customer.name}</Typography>
          <Button size="small" className={classes.settingsButton} variant="contained" color='primary' onClick={()=>this.props.history.push(`/customers/${customerId}/edit`)}>Settings<Settings className={classes.icon}/></Button>
        </Grid>

        <Grid item xs={6} sm={4}>
          <Paper className={classes.paper}>
            <Typography align='center' variant='display3'>{customer.inventory_locations_count}</Typography>
            <Typography align='center' variant='subheading'>Inventory locations</Typography>
          </Paper>    
        </Grid>

        <Grid item xs={6} sm={4}>
          <Paper className={classes.paper}>
            <Typography align='center' variant='display3'>{customer.total_capacity}</Typography>
            <Typography align='center' variant='subheading'>Total capacity</Typography>
          </Paper>    
        </Grid>

        <Grid item xs={12} md={8}>
            <CustomerInventoryLocations/>
        </Grid>
        <Grid item xs={12}>
            <CustomerTransactions customerId={customerId}/>
        </Grid>
        <Grid item xs={12}>
          <InventoryLocationsMap/>
        </Grid>
        <Grid item xs={12} md={6}>
          <CustomerUsers customerId={customerId}/>
        </Grid>
      </Grid>
    );
  }
}


const styles = theme => ({
  paper:{
    padding: 20
  },
  icon:{
    marginLeft: 5
  },
});

export default withStyles(styles)(Customer);


// WEBPACK FOOTER //
// ./src/components/Customer.js